import {VNode} from 'snabbdom/vnode';
import {Component, jsx} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {IronContextRegistry} from 'common/report/context-registry';
import {DummyLocalStorageManager} from 'common/contexts/local-storage-manager/dummy';
import {DummyUrlManager} from 'common/contexts/url-manager/dummy';

interface JsxProps {
  attrs: EmptyObj;
}

// This is a blank, unstyled, non-shadow-DOM component designed only to wrap existing DOM structures so it can act as a Panel Context root for the DOM descendants under it.
// This context root is designed for mocking contexts in test environments.
export class TestContextRoot extends Component<EmptyObj, JsxProps['attrs'], unknown, unknown, IronContextRegistry> {
  constructor(defaultContexts?: Partial<IronContextRegistry>) {
    super();

    if (defaultContexts) {
      this.setConfig(`defaultContexts`, defaultContexts);
    }

    // this needs to be done because isotest relies on document.createElement shim
    // to populate nodeName and tageName properties but test context root is expected
    // to be constructed manually
    if (!this.nodeName) {
      // @ts-ignore
      this.nodeName = `test-context-root`;
    }
    if (!this.tagName) {
      // @ts-ignore
      this.tagName = `test-context-root`;
    }
  }

  get config() {
    return {
      template: (): VNode => <div />,
      defaultContexts: {
        localStorageManager: new DummyLocalStorageManager(),
        urlManager: new DummyUrlManager(),
      },
    };
  }
}

export const TestContextRootEl = defineAndMakeJsxFactory<JsxProps>(`mp-test-context-root`, TestContextRoot);
